// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-items {
  background-color: var(--white);
  overflow: auto;
  white-space: nowrap;
  display: flex;
  width: 85%;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  overflow-x: hidden;
}

.nav-items p {
  border-right: 2px solid var(--border-color);
  display: inline-block;
  color: black;
  text-align: center;
  margin-bottom: 0px;
  text-decoration: none;
  padding-right: 1em;
}

.nav-items div:hover {
  background-color: var(--primary-color-light);
  cursor: pointer;
}

.nav-items div {
  margin: 1em 0em 1em 1em;
  display: flex;
  align-items: center;
}

.menu-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 3em;
}

.nav-buttons {
  border: none;
  background-color: var(--primary-color-light);
  text-align: center;
  padding: 2px 11px;
  border: 1px solid transparent;
  border-radius: 50px;
  cursor: pointer;
  margin: 1em;
}
.nav-buttons:hover {
  background-color: var(--white);
  color: var(--primary-color-light);
  border: 1px solid var(--primary-color-light);
}

.nav-buttons svg {
  font-size: inherit;
  color: var(--primary-color);
}

.completed-step-icon {
  margin-right: 5px;
  padding: 0px 4px;
  border-radius: 50%;
  font-size: x-small;
}

.completed-step-icon {
  background: #00ba0033;
  color: #00ba00;
}

.incomplete-step-icon {
  margin-right: 5px;
  padding: 0px 7px;
  border-radius: 50%;
  font-size: x-small;
}

.incomplete-step-icon {
  background: #ba7f0033;
  color: #ba3b00;
}
`, "",{"version":3,"sources":["webpack://./src/Calendar/assets/scheduler/css/components/stepSlider.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;EAC5C,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,4CAA4C;EAC5C,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;AACA;EACE,8BAA8B;EAC9B,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB","sourcesContent":[".nav-items {\n  background-color: var(--white);\n  overflow: auto;\n  white-space: nowrap;\n  display: flex;\n  width: 85%;\n  border: 1px solid var(--border-color);\n  border-radius: 4px;\n  overflow-x: hidden;\n}\n\n.nav-items p {\n  border-right: 2px solid var(--border-color);\n  display: inline-block;\n  color: black;\n  text-align: center;\n  margin-bottom: 0px;\n  text-decoration: none;\n  padding-right: 1em;\n}\n\n.nav-items div:hover {\n  background-color: var(--primary-color-light);\n  cursor: pointer;\n}\n\n.nav-items div {\n  margin: 1em 0em 1em 1em;\n  display: flex;\n  align-items: center;\n}\n\n.menu-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin-bottom: 3em;\n}\n\n.nav-buttons {\n  border: none;\n  background-color: var(--primary-color-light);\n  text-align: center;\n  padding: 2px 11px;\n  border: 1px solid transparent;\n  border-radius: 50px;\n  cursor: pointer;\n  margin: 1em;\n}\n.nav-buttons:hover {\n  background-color: var(--white);\n  color: var(--primary-color-light);\n  border: 1px solid var(--primary-color-light);\n}\n\n.nav-buttons svg {\n  font-size: inherit;\n  color: var(--primary-color);\n}\n\n.completed-step-icon {\n  margin-right: 5px;\n  padding: 0px 4px;\n  border-radius: 50%;\n  font-size: x-small;\n}\n\n.completed-step-icon {\n  background: #00ba0033;\n  color: #00ba00;\n}\n\n.incomplete-step-icon {\n  margin-right: 5px;\n  padding: 0px 7px;\n  border-radius: 50%;\n  font-size: x-small;\n}\n\n.incomplete-step-icon {\n  background: #ba7f0033;\n  color: #ba3b00;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
